import { createReducer, on } from '@ngrx/store';
import { HttpError, UserInfo } from '@rd/types';
import { TransactionStatus } from '@rd/types/transaction-status.type';
import {
  LoadUserInfo,
  LoadUserInfoFail,
  LoadUserInfoSuccess,
} from '../actions/user-info.actions';

export interface UserInfoState {
  status: TransactionStatus;
  data: UserInfo | null;
  error: HttpError | null;
}

const initialState: UserInfoState = {
  status: TransactionStatus.INITIAL,
  data: null,
  error: null,
};

export const userInfoReducer = createReducer(
  initialState,
  on(LoadUserInfo, (state: UserInfoState) => ({
    ...state,
    status: TransactionStatus.LOADING,
    error: null,
  })),
  on(LoadUserInfoSuccess, (state: UserInfoState, { type, ...payload }) => ({
    status: TransactionStatus.SUCCESS,
    data: payload,
    error: null,
  })),
  on(LoadUserInfoFail, (state: UserInfoState, { type, ...payload }) => ({
    ...state,
    status: TransactionStatus.FAIL,
    error: payload,
  })),
);
